import {
  finalizeHandoffSurveyInput,
  finalizeHandoffSurveyOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/finalize-handoff-survey";
import { unaryRpc } from "@redotech/rpc/definition";

// Submits the completed handoff survey to the partner and returns the redirect.
export const finalizeHandoffSurvey = unaryRpc({
  name: "finalizeHandoffSurvey",
  input: finalizeHandoffSurveyInput,
  output: finalizeHandoffSurveyOutput,
});
